import { useSearchParams } from 'react-router-dom';
import { ContactForm } from './ContactForm';

export function ContactNew() {
  const [params] = useSearchParams();
  const account = params.get('account') ?? undefined;
  return <ContactForm mode={{ kind: 'create', prefillAccountId: account }} />;
}
